module.exports = __webpack_public_path__ + "img/calendar-icon.aff2c354.svg";